import axios from 'axios';
import { getAuthHeaders } from './userController';

const HORARIO_URL = 'https://yokomo.api.ikeytechnologies.com/horarios/';

// Obtener todos los horarios
export const fetchHorarios = async () => {
  try {
    const response = await axios.get(HORARIO_URL, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener los horarios:', error);
    throw error;
  }
};

// Obtener un horario por ID
export const fetchHorario = async (id) => {
  try {
    const response = await axios.get(`${HORARIO_URL}${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al obtener el horario:', error);
    throw error;
  }
};

// Crear un nuevo horario
export const createHorario = async (data) => {
  try {
    const response = await axios.post(HORARIO_URL, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al crear el horario:', error);
    throw error;
  }
};

// Actualizar un horario
export const updateHorario = async (id, data) => {
  try {
    const response = await axios.put(`${HORARIO_URL}${id}/`, data, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al actualizar el horario:', error);
    throw error;
  }
};

// Eliminar un horario
export const deleteHorario = async (id) => {
  try {
    const response = await axios.delete(`${HORARIO_URL}${id}/`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error('Error al eliminar el horario:', error);
    throw error;
  }
};
